const cents = value => Math.round(Number(value || 0) * 100);

// Only saved monetary fields explain history; current grants cannot fill legacy gaps.
function buildStudentSettlementSummary(settlement) {
  const groups = new Map();
  let knownDiscountCents = 0;
  let unknownHistoryCount = 0;
  let itemTotalCents = 0;
  ((settlement.snapshot && settlement.snapshot.charged) || []).forEach(item => {
    const key = item.studentId || null;
    if (!groups.has(key)) {
      groups.set(key, {
        studentId: key,
        studentName: item.studentName || key,
        baseAmountCents: 0,
        discountAmountCents: 0,
        finalAmountCents: 0,
        unknownHistoryCount: 0,
      });
    }
    const group = groups.get(key);
    const known = Number.isInteger(item.baseAmountCents) && Number.isInteger(item.discountAmountCents) && Number.isInteger(item.finalAmountCents);
    const finalAmountCents = known ? item.finalAmountCents : cents(item.amount);
    group.finalAmountCents += finalAmountCents;
    itemTotalCents += finalAmountCents;
    if (known) {
      group.baseAmountCents += item.baseAmountCents;
      group.discountAmountCents += item.discountAmountCents;
      knownDiscountCents += item.discountAmountCents;
    } else {
      group.unknownHistoryCount += 1;
      unknownHistoryCount += 1;
    }
  });
  const other = groups.get(null) || { studentId: null, baseAmountCents: 0, discountAmountCents: 0, finalAmountCents: 0, unknownHistoryCount: 0 };
  const enrollmentCents = cents(settlement.enrollmentChargesInMonth);
  other.baseAmountCents += enrollmentCents;
  other.finalAmountCents += enrollmentCents;
  const unexplainedCents = cents(settlement.monthlyChargeAmount) - itemTotalCents - enrollmentCents;
  if (unexplainedCents !== 0) {
    other.finalAmountCents += unexplainedCents;
    other.unknownHistoryCount += 1;
    unknownHistoryCount += 1;
  }
  return {
    students: [...groups.values()].filter(group => group.studentId !== null),
    otherCharges: other,
    finalAmountCents: cents(settlement.monthlyChargeAmount),
    knownDiscountCents,
    unknownHistoryCount,
  };
}

export { buildStudentSettlementSummary };
export default buildStudentSettlementSummary;
